import {Expiry, ExpiryType} from "./ExpiryService";
import {Optional} from "../../js/util/Optional";
import {IsoDate, IsoDateString} from "../../pseudo-types/DateTypes";
import moment = require("moment");

export class Expiries {

    public readonly first: IsoDate;
    public readonly last: IsoDate;

    private readonly sortedDates: Array<IsoDate>;

    public constructor(public readonly expiries: Array<Expiry>) {
        this.sortedDates = this.sortDates(expiries);
        this.first = this.sortedDates[0];
        this.last = this.sortedDates[this.sortedDates.length - 1];
    }

    private sortDates(expiries: Array<Expiry>): Array<IsoDate> {
        return expiries.map((exp) => exp.date)
                       .sort()
                       .map((d) => IsoDateString(d));
    }

    public forUnderlying(code: String): Expiries {
        const isIndex = code === "XJO";
        const isEquity = !isIndex;

        const validExpiries = this.expiries.filter(e => e.index === isIndex || e.equity === isEquity);
        return new Expiries(validExpiries);
    }

    public ofType(...expiryType: Array<ExpiryType>): Expiries {
        const validExpiries = this.expiries.filter(e => expiryType.includes(e.expiryType));

        return new Expiries(validExpiries);
    }

    public after(afterDate: string): Expiries {
        const validExpiries = this.expiries.filter(e => e.date > afterDate);
        return new Expiries(validExpiries);
    }

    public between(from: string, to: string) {
        const isBetween = (expiry: Expiry) => {
            const str = moment(expiry.date).format("YYYY-MM-DD");

            const afterFrom = str.localeCompare(from) >= 0;
            const beforeToday = str.localeCompare(to) <= 0;
            return afterFrom && beforeToday;
        };

        const validExpiries = this.expiries.filter(isBetween);

        return new Expiries(validExpiries);
    }

    public expiryDates(): Array<IsoDate> {
        return this.expiries.map(e => e.date);
    }

    public expiryFor(date: string) {
        return Optional.of(this.expiries.find(e => e.date === date));
    }

    public clone() {
        return new Expiries(this.expiries);
    }
}
